<table class="sc-table" [ngClass]="{'sc-table--selectable': rowSelectable }">
  <thead class="sc-table__head hidden-sm">
    <tr class="sc-table__head-row">
      <ng-container *ngTemplateOutlet="rowHeaderTemplate"></ng-container>
    </tr>
  </thead>
  @if (!loading && items && items.length) {
    <tbody class="sc-table__body" [@tableListAnimation]="items.length">
      @for (item of items; track item; let index = $index) {
        <tr [class]="(id) ? 'sc-table__body-row ' + id + '__row' : 'sc-table__body-row'" (click)="selectRow(item)">
          <ng-container *ngTemplateOutlet="rowItemTemplate, context: { item: item, index: index }"></ng-container>
        </tr>
      }
    </tbody>
  }
  @if (loading) {
    <tbody class="sc-table__placeholder-body" [@timelineListAnimation]="items.length">
      @for (number of placeholderItems; track number; let index = $index) {
        <tr class="sc-table__placeholder-body-row timeline animated-background">
          <ng-container *ngTemplateOutlet="rowItemPlaceholderTemplate, context: { item: item, index: index }"></ng-container>
        </tr>
      }
    </tbody>
  }
</table>